import { Box, Grid, } from "@mui/material";
import HoneypotTable from './HoneypotTable';
import React, { useState } from 'react';
import PeriodFilters from "./PeriodFilters";
import {  useGetPeriodQuery } from "../../../services/PaymentToolApi";
import HoneypotTableHeaderInfo from "./HoneypotTableHeaderInfo";
import { getCurrentPeriod } from "../../../utils/PaymentToolsUtils";

import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../features/auth/authSlice";

function getYearsFrom() {
  let years = [];
  let currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= 2024; i--) {
    years.push(i);
  }
  return years;
}

const Honeypot = () => {
  const user= useSelector(selectCurrentUser);

  let years = getYearsFrom();
  const [selectedYear, setSelectedYear] = useState(years.find(year => year === new Date().getFullYear()) || 2021);
  const currentPeriod = getCurrentPeriod()
  const [selectedPeriod, setSelectedPeriod] = useState(currentPeriod);
  const { data: period, isLoading: periodIsLoading, isFetching: periodIsFetching, error: periodError } = useGetPeriodQuery({
    period: selectedPeriod
  }, { skip: !selectedPeriod});
  
  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >

        {/* Title */}
        <h3
          style={{ width: '100%', margin: ' 0 0 0 0', color: 'var(--orange)' }}>
          Honeypot
        </h3>

        {/* Selects  */}
        <PeriodFilters
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          years={years}
          userId={user.id}
        />

        {/* Table Header  */}
        <HoneypotTableHeaderInfo 
          selectedYear={selectedYear} 
          selectedPeriod={selectedPeriod} 
          period={period} 
          userId={user.id} 
        />

        {/* Table Component  */}
        <HoneypotTable
          selectedPeriod={selectedPeriod}
          selectedYear={selectedYear}
        />

      </Grid>
    </Box >
  );
}

export default Honeypot;
